import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
  class: "member_department_body"
};
const _hoisted_2 = {
  class: "navbat"
};
const _hoisted_3 = {
  class: "member_department_body_nr"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = ["src"];
const _hoisted_6 = {
  style: {
    "font-size": "30px"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
    src: "https://www.mimodental.com/assets/imgData/imgs/fh.png",
    alt: "",
    onClick: _cache[0] || (_cache[0] = (...args) => $setup.fh && $setup.fh(...args))
  }), _cache[1] || (_cache[1] = _createElementVNode("span", null, "诊疗科室", -1))]), _createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.list, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "nrdome",
      key: index,
      onClick: $event => $setup.go(item)
    }, [_createElementVNode("img", {
      src: 'https://www.mimodental.com/assets/imgData/img/new/' + item.img + '.png',
      class: "icon"
    }, null, 8, _hoisted_5), _createElementVNode("div", null, [_createElementVNode("h2", null, _toDisplayString(item.name), 1), _createElementVNode("span", _hoisted_6, _toDisplayString(item.text), 1)])], 8, _hoisted_4);
  }), 128))])]);
}